/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface CodePostalSearch
 */
export interface CodePostalSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof CodePostalSearch
     */
    codePostal?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof CodePostalSearch
     */
    commune?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof CodePostalSearch
     */
    localite?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof CodePostalSearch
     */
    pays?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof CodePostalSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof CodePostalSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CodePostalSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CodePostalSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof CodePostalSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof CodePostalSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CodePostalSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof CodePostalSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CodePostalSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the CodePostalSearch interface.
 */
export function instanceOfCodePostalSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CodePostalSearchFromJSON(json: any): CodePostalSearch {
    return CodePostalSearchFromJSONTyped(json, false);
}

export function CodePostalSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodePostalSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'codePostal': !exists(json, 'codePostal') ? undefined : TextSearchFromJSON(json['codePostal']),
        'commune': !exists(json, 'commune') ? undefined : TextSearchFromJSON(json['commune']),
        'localite': !exists(json, 'localite') ? undefined : TextSearchFromJSON(json['localite']),
        'pays': !exists(json, 'pays') ? undefined : TextSearchFromJSON(json['pays']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function CodePostalSearchToJSON(value?: CodePostalSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'codePostal': TextSearchToJSON(value.codePostal),
        'commune': TextSearchToJSON(value.commune),
        'localite': TextSearchToJSON(value.localite),
        'pays': TextSearchToJSON(value.pays),
        'actif': BooleanSearchToJSON(value.actif),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

